<panel width="450">
	<h1>{{ 'salesflowlist.open' | translate }}</h1>
	<list-view [emptyLabel]="'salesflowlist.open.salesflow-list-empty-label'">
		<header>{{ 'taskflowlist.status' | translate }}</header>
		<header defaultSort="descending">{{ 'taskflowlist.owner' | translate }}</header>
		<header align-right>{{ 'taskflowlist.planned-date' | translate }}</header>
		<row *listData="let taskflow from openSalesflows" [highlighted]="selectedTaskflowId == taskflow.id" (action)="selectedTaskflowId = taskflow.id" [statusColor]="getStatusColor(taskflow)">
			<column>{{ getStatus(taskflow) | translate }}</column>
			<column>{{ getOwner(taskflow) }}</column>
			<column align-right>{{ taskflow.completed ? taskflow.completed : taskflow.created | customDate: 'shortDate' }}</column>
		</row>
	</list-view>
	@if (loading) {
		<skeleton />
	}
	<h1>{{ 'salesflowlist.closed' | translate }}</h1>
	<list-view [emptyLabel]="'salesflowlist.closed.salesflow-list-empty-label'">
		<header>{{ 'taskflowlist.status' | translate }}</header>
		<header defaultSort="descending">{{ 'taskflowlist.owner' | translate }}</header>
		<header align-right>{{ 'taskflowlist.planned-date' | translate }}</header>
		<row *listData="let taskflow from closedSalesflows" [highlighted]="selectedTaskflowId == taskflow.id" (action)="selectedTaskflowId = taskflow.id" [statusColor]="getStatusColor(taskflow)">
			<column>{{ getStatus(taskflow) | translate }}</column>
			<column>{{ getOwner(taskflow) }}</column>
			<column align-right>{{ taskflow.completed ? taskflow.completed : taskflow.created | customDate: 'shortDate' }}</column>
		</row>
	</list-view>
	@if (loading) {
		<skeleton />
	}
</panel>

@if (selectedTaskflowId && !loading) {
	<view-salesflow [taskflowId]="selectedTaskflowId" [companyId]="companyId" />
}
@if (selectedTaskflowId == undefined && !loading) {
	<view-salesflow [taskflowId]="''" [companyId]="companyId" />
}
@if (loading) {
	<panel width="800">
		<h1><skeleton /></h1>
		<section><skeleton /></section>
		<section>
			<div class="row button-row">
				<div class="col-2">
					<skeleton height="50px" />
				</div>
				<div class="col-3">
					<skeleton height="50px" />
				</div>
				<div class="col-2">
					<skeleton height="50px" />
				</div>
				<div class="col-3">
					<skeleton height="50px" />
				</div>
				<div class="col-2">
					<skeleton height="50px" />
				</div>
			</div>
		</section>
	</panel>
}
<panel width="420">
	<h1>{{ 'company.contact-information' | translate }}</h1>
	<company-information [company]="company" />
	<list-contact [company]="company" />
</panel>
